export const tenant = "0000100000";
